/*! Copyright (c) Safe As Milk. All rights reserved. */
function tabClick(e) {
    if (e.keyCode === 9) {
        document.body.classList.add("js-using-tab");
        window.removeEventListener("keydown", tabClick);
    }
}

window.addEventListener("keydown", tabClick);

window.theme ??= {};

window.theme.wrapRteTables = (rootElement = document) => {
    const wrapTable = (el, wrapper) => {
        el.parentNode.insertBefore(wrapper, el);
        wrapper.appendChild(el);
    };
    rootElement.querySelectorAll(".rte table").forEach((table => {
        if (table.closest(".js-theme-utility-rte-table-wrap")) return;
        const tableWrapper = document.createElement("div");
        tableWrapper.classList.add("js-theme-utility-rte-table-wrap");
        tableWrapper.setAttribute("style", "overflow:auto;-webkit-overflow-scrolling:touch");
        wrapTable(table, tableWrapper);
    }));
};

window.theme.wrapRteTables();

const scrollEndSupported = typeof window === "undefined" ? true : "onscrollend" in window;

if (!scrollEndSupported) {
    import("scrollyfills");
}

/*============================================================================
  Rebuy Cart Drawer Integration - Simple jQuery Solution
  On click of 3 classes, check rebuy-cart__flyout length
  If length > 0, allow click. Otherwise, disable it.
==============================================================================*/
(function($) {
    'use strict';

    // Bundle checkout buttons use Cart API + redirect — never open drawer
    document.addEventListener('click', function(e) {
        if (e.target.closest('.js-bundle-checkout-link')) {
            e.stopPropagation();
        }
    }, true);

    $(document).on('click', 'a[href*="/cart"], a[href*="cart"]', function(e) {
        if ($(this).hasClass('js-bundle-checkout-link')) {
            return;
        }

        const href = $(this).attr('href') || '';
        const urlPath = href.toLowerCase();

        // Cart permalinks with variant IDs must navigate — not open drawer
        if (/\/cart\/\d+:\d+/i.test(href)) {
            return;
        }
        
        // Check if URL contains /cart
        if (urlPath.includes('/cart') || urlPath.includes('cart')) {
            // Check if rebuy-cart__flyout exists
            const rebuyCartLength = $('.rebuy-cart__flyout').length;
            
            if (rebuyCartLength > 0) {
                // Flyout exists - prevent redirect and open drawer
                e.preventDefault();
                e.stopPropagation();
                
                // Open theme cart drawer (Rebuy will handle it)
                if (typeof window.theme !== 'undefined' && typeof window.theme.mfpOpen === 'function') {
                    window.theme.mfpOpen("cart");
                }
                
                console.log('✓ Cart URL prevented - drawer opened');
            } else {
                // Flyout not found - prevent redirect
                e.preventDefault();
                e.stopPropagation();
                console.warn('✗ Cart URL prevented - rebuy-cart__flyout not found');
            }
        }
    });
    // Click handler for 3 classes
    $(document).on('click', '.js-cart-icon, .secondary-nav__item--cart, .cart-notification__checkout', function(e) {
        // Check if rebuy-cart__flyout exists
        const rebuyCartLength = $('.rebuy-cart__flyout').length;
        
        console.log('Cart click - rebuy-cart__flyout length:', rebuyCartLength);
        
        if (rebuyCartLength > 0) {
            // Flyout exists - allow click and open drawer
            e.preventDefault();
            e.stopPropagation();
            
            // Open theme cart drawer (Rebuy will handle it)
            if (typeof window.theme !== 'undefined' && typeof window.theme.mfpOpen === 'function') {
                window.theme.mfpOpen("cart");
            }
            
            console.log('✓ Click allowed - rebuy-cart__flyout found');
        } else {
            // Flyout not found - disable click
            e.preventDefault();
            e.stopPropagation();
            console.warn('✗ Click disabled - rebuy-cart__flyout not found');
        }
    });
    
})(jQuery);
//# sourceMappingURL=global.js.map
 